/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DevisResource } from '../models/DevisResource';
import type { QuoteRequest } from '../models/QuoteRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class QuoteService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Devis d'une periode
     * Entre `DATE_DEBUT` et `DATE_FIN`, avec projet, client et adresse de chantier. Par defaut, seuls les devis des projets du personnel connecte ; `ALL=1` les renvoie tous. `TYPE` : `attente` (non refuses, non signes, montant positif, projet actif), `ranking` (signes sur la periode), `classement`, `all`. `TYPE=birthday` renvoie a la place les clients dont c'est l'anniversaire, sans autre parametre.
     * @param dateDebut
     * @param dateFin
     * @param type
     * @param all
     * @returns DevisResource Array of `DevisResource`
     * @throws ApiError
     */
    public devisIndex(
        dateDebut: string,
        dateFin: string,
        type?: 'attente' | 'classement' | 'all' | 'ranking' | 'birthday',
        all?: boolean,
    ): CancelablePromise<Array<DevisResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/devis',
            query: {
                'DATE_DEBUT': dateDebut,
                'DATE_FIN': dateFin,
                'TYPE': type,
                'ALL': all,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer un devis
     * Date du jour, sur le projet `IDPROJET` pour le client `IDCLIENT`. Les lignes du devis se gerent dans Lola.
     * @param requestBody
     * @returns DevisResource `DevisResource`
     * @throws ApiError
     */
    public devisStore(
        requestBody: QuoteRequest,
    ): CancelablePromise<DevisResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/devis',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un devis
     * Avec le projet, le client et les lignes du devis.
     * @param id
     * @returns DevisResource `DevisResource`
     * @throws ApiError
     */
    public devisShow(
        id: string,
    ): CancelablePromise<DevisResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/devis/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Modifier le suivi d'un devis
     * Ne met a jour que `INDICE_CONFIANCE` et `COMMENTAIRE` ; le contenu du devis se modifie dans Lola. 404 si le devis n'existe pas.
     * @param id
     * @param requestBody
     * @returns DevisResource `DevisResource`
     * @throws ApiError
     */
    public devisUpdate(
        id: string,
        requestBody: QuoteRequest,
    ): CancelablePromise<DevisResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/devis/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Refuser un devis
     * Le devis n'est pas supprime : il est marque refuse et sort des listes en attente. Renvoie le devis. 404 s'il n'existe pas.
     * @param id
     * @returns DevisResource `DevisResource`
     * @throws ApiError
     */
    public devisDestroy(
        id: string,
    ): CancelablePromise<DevisResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/devis/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
